import React from 'react';
import styled from 'styled-components';
import { Switch as AntSwitch } from 'antd';
import { Colors } from 'basic-ui-lib/constants';

export interface SwitchProps {
  value?: boolean;
  onChange?: (val: boolean) => void;
  style?: React.CSSProperties;
  disabled?: boolean;
  loading?: boolean;
}

const StyledSwitch = styled(AntSwitch)`
  &.ant-switch {
    display: flex;
    width: 40px;
    min-width: 40px;
    height: 24px;
    padding: 0;
    align-items: center;
    flex-shrink: 0;
    border-radius: 16px;
    
    // Inactive state
    background: ${Colors.neutral.bg[7]};
    
    // Active state
    &.ant-switch-checked {
      background: ${Colors.primary[5]};
      
      &:hover {
        background: ${Colors.primary[5]};
      }
      
      .ant-switch-handle {
        inset-inline-start: calc(100% - 20px) !important;
      }
    }

    // Handle (circle) styling
    .ant-switch-handle {
      width: 16px;
      height: 16px;
      inset-block-start: 4px;
      inset-inline-start: 4px;
      transition: all 0.2s ease-in-out;

      &::before {
        border-radius: 50%;
        background-color: white;
        width: 16px;
        height: 16px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      }
    }

    // Remove the inner loading icon if any
    .ant-switch-inner {
      display: none;
    }
  }
`;

const Switch: React.FC<SwitchProps> = ({
  value = false,
  onChange,
  style,
  disabled,
  loading,
}) => {
  return (
    <StyledSwitch 
      checked={value} 
      onChange={onChange}
      disabled={disabled}
      loading={loading}
      style={style}
    />
  );
};

export default Switch; 